module.exports = __webpack_public_path__ + "static/media/kitchen-1940174_1920.aab7a991.jpg";